import { Locale } from '@susu/custom-made/i18n-config';
import { Clients, ClientType, ConfiguratorOrigin, ConfiguratorOriginsType } from '@susu/custom-made/utils/constants';
import { ProductType } from '@susu/custom-made/utils/productDefinition';
import { createContext } from 'react';

type UserContextType = {
  accountNr?: string;
  setAccountNr: (accountNr: string) => void;
  countryCode: string;
  setCountryCode: (countryCode: string) => void;
  client: ClientType;
  setClient: (client: ClientType) => void;
  language: Locale;
  setLanguage: (language: Locale) => void;
  product: ProductType | undefined;
  setProduct: (product: ProductType | undefined) => void;
  origin: ConfiguratorOriginsType;
  setOrigin: (origin: ConfiguratorOriginsType) => void;
  rtwProductCodes: string[];
  setRtwProductCodes: (rtwProductCodes: string[]) => void;
  storeID?: string;
  setStoreID: (storeID: string) => void;
  locationCode?: string;
  setLocationCode: (locationCode: string) => void;
  sizeId?: string;
  setSizeId: (sizeId: string) => void;
  channelId?: string;
  setChannelId: (channelId: string) => void;
  isUserPreselected: boolean;
  setIsUserPreselected: (isUserPreselected: boolean) => void;
};

export const defaultUserContext: UserContextType = {
  accountNr: undefined,
  setAccountNr: () => {},
  countryCode: 'NL',
  setCountryCode: () => {},
  client: Clients.onLine as ClientType,
  setClient: () => {},
  language: 'en',
  setLanguage: () => {},
  product: undefined,
  setProduct: () => {},
  storeID: undefined,
  setStoreID: () => {},
  locationCode: undefined,
  setLocationCode: () => {},
  sizeId: undefined,
  setSizeId: () => {},
  channelId: undefined,
  setChannelId: () => {},
  origin: ConfiguratorOrigin.Normal,
  setOrigin: () => {},
  rtwProductCodes: [],
  setRtwProductCodes: () => {},
  isUserPreselected: false,
  setIsUserPreselected: () => {},
};

export const UserContext = createContext<UserContextType>(defaultUserContext);
